'use strict';

angular.module('TurneroApp').component('coAppExterna', {
    bindings: {
        idAgenda: '<',
        idTramiteRelevado: '<',
        ctrlPadre: '='
    },
    controller: [
         'utilsService',
         'TurneroAppConstant',
         'appExternaService',
         function (utilsService, TurneroAppConstant, appExternaService) {
             var ctrl = this;
             ctrl.Tipo_Columna = TurneroAppConstant.Tipo_Columnas;

             ctrl.$onChanges = function () {
                 if (ctrl.idAgenda && ctrl.idTramiteRelevado) {
                     ctrl.GetFormulario()
                 }
             }

             ctrl.$onInit = function () {
                 ctrl.ctrlPadre.ConfirmacionAppExterna = ctrl.Confirmacion;
             }
             
             ctrl.validarAppExterna_Requerido = function (Campos) {
                 if (Campos.length) {
                     for (var i = 0; i < Campos.length; i++) {
                         Campos[i].errores = false;
                         if (Campos[i].Requerido == 'S' && !Campos[i].N_Valor) {
                             Campos[i].errores = true;
                             return false;
                         }
                     }
                 }
                 return true
             }

             ctrl.Confirmacion = function () {
                 ctrl.input_aplicacion_externa = null;
                 if (ctrl.validarAppExterna_Requerido(ctrl.appExterna.Columnas)) {
                     var Campos = ctrl.appExterna.Columnas;
                     ctrl.input_aplicacion_externa = null;
                     if (Campos.length) {
                         for (var i = 0; i < Campos.length; i++) {
                             ctrl.input_aplicacion_externa = ctrl.input_aplicacion_externa ? (ctrl.input_aplicacion_externa + '|' + Campos[i].Id_Columna + '@@' + Campos[i].N_Valor) : (Campos[i].Id_Columna + '@@' + Campos[i].N_Valor);
                         }
                     }
                     ctrl.ctrlPadre.input_App_Externa = ctrl.input_aplicacion_externa;
                     ctrl.ctrlPadre.GuardarTurno();
                 }

             }

             //ctrl.Cancelar = function () {
             //    ctrl.ctrlPadre.cancelar();
             //}
             
             ctrl.GetFormulario = function () {
                 appExternaService.Traer_Formulario({ 'Id_Agenda': ctrl.idAgenda, 'Id_Tramite_Relevado': ctrl.idTramiteRelevado }).$promise.then(function (resultado) {
                     ctrl.ctrlPadre.d2.resolve();
                     ctrl.appExterna = resultado.Data;
                     ctrl.ctrlPadre.appExterna = ctrl.appExterna;
                 }).catch(function (error) {
                     ctrl.ctrlPadre.d2.resolve();
                     utilsService.errores(error);
                 });
             }
         }],
    template: require('./appExterna.html')
});



// WEBPACK FOOTER //
// ./app/components/appExterna/appExternaComponent.js